
(() => {
  const storageKey = 'sugandh-grid-layout';

  function initLayoutSwitcher() {
    const toolbar = document.querySelector(
      '.sugandh-layout-switcher'
    );

    if (!toolbar || toolbar.dataset.initialized) return;
    toolbar.dataset.initialized = 'true';

    function applyLayout(layout) {
      const grid = document.querySelector('#product-grid');
      if (!grid) return;

      grid.classList.toggle(
        'sugandh-grid-spacious',
        layout === 'spacious'
      );

      if (layout === 'compact') {
        grid.classList.remove('grid--3-col-desktop');
        grid.classList.add('grid--4-col-desktop');
      } else {
        grid.classList.remove('grid--4-col-desktop');
        grid.classList.add('grid--3-col-desktop');
      }

      toolbar.querySelectorAll('[data-grid-layout]')
        .forEach((button) => {
          button.setAttribute(
            'aria-pressed',
            String(button.dataset.gridLayout === layout)
          );
        });
    }

    toolbar.addEventListener('click', (event) => {
      const button = event.target.closest('[data-grid-layout]');
      if (!button) return;

      const layout = button.dataset.gridLayout;
      applyLayout(layout);

      try {
        localStorage.setItem(storageKey, layout);
      } catch (_) {}
    });

    let savedLayout = 'compact';

    try {
      savedLayout = localStorage.getItem(storageKey) || 'compact';
    } catch (_) {}

    applyLayout(savedLayout);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLayoutSwitcher);
  } else {
    initLayoutSwitcher();
  }
})();
